export interface IOwnerResponse {
	currentPage: number;
	data: IOwnerDto[];
	maxPages: number;
}

export interface IOwnerDto {
	owner_id?: string;
	name?: string;
}

export enum OwnerField {
	OwnerId = "owner_id",
	Name = "name"
}
